<main class="circle-gradient-1">
    <section class="breadcrumb-sec event-sec">
        <div class="container">
            <div class="row g-0">
                <div class="col-lg-6 col-md-6">
                    <ul class="breadcrumb">
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li><a href="events">Events</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li><a routerLink="/events" fragment="sports">Sports</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li>NSS CAMP</li>
                    </ul>
                    <div class="sec-title">
                        <h1><span>NSS CAMP 2025</span></h1>
                        <p>The G H Raisoni College of Arts, Commerce and Science Wagholi
                            successfully organized a 07-days NSS (National Service Scheme) camp at Awahalwadi from
                            10/02/2025 to 16/02/2025 The camp aimed to instil a spirit of service, leadership, and
                            community engagement among the volunteers.
                        </p>

                    </div>
                </div>
            </div>
            <div class="breadcrumb-overlay overflow-hidden"
                  style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-8.webp);">
              </div>
        </div>
    </section>
    <section class="section-lg">
      <div class="container">
        <div class="sec-title text-center">
            <h2><span>Photo Gallery</span></h2>
        </div>
        <div class="demo-gallery">
             <ul  appLightgallery>
              <li class="grid-item1"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-5.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-5.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-5.webp">
                  </a>
              </li>
              <li class="grid-item2"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-1.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-1.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-1.webp">
                  </a>
              </li>
              <li class="grid-item3 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-2.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-2.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-2.webp">
                  </a>
              </li>
              <li class="grid-item4 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-3.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-3.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-3.webp">
                  </a>
              </li>
              <li class="grid-item5 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-4.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-4.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-4.webp">
                  </a>
              </li>
              <li class="grid-item6 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-6.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-6.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/nss-camp-6.webp">
                  </a>
              </li>
          </ul>
        </div>
      </div>
    </section>
</main>
